import { render, staticRenderFns } from "./CrewForm.vue?vue&type=template&id=bd73c9fa"
import script from "./CrewForm.vue?vue&type=script&lang=js"
export * from "./CrewForm.vue?vue&type=script&lang=js"
import style0 from "./CrewForm.vue?vue&type=style&index=0&id=bd73c9fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports